import * as apis from '@apis'
const column = {
  namespaced: true,
  state: {
    columns: [],
    currentColumn: null,
    metadata: {
      'mod': 'set-column',
      'ch': 2
    },
    expandColumn: []
  },
  getters: {},
  mutations: {
    UPDATE_COLUMNS (state, data) {
      state.columns = data
    }
  },
  actions: {
    FETCH_COLUMNS ({state, commit}, params) {
      let config = {
        params: {
          parent: 0,
          type: 0,
          ch: 2,
          siteID: state.site,
          ...params
        }
      }
      return apis.MediaCloudConfigColumn.getColumns(config).then(res => {
        if (res.data.data && res.data.data.lists) {
          commit('UPDATE_COLUMNS', res.data.data.lists)
        }
        return res.data
      })
    },
    UPDATE_CURRENT_COLUMN ({state}, data) {
      state.currentColumn = data
    },
    updateExpandColumn ({state}, val) {
      state.expandColumn = val
    }
  }
}

export default column
